export default "__VITE_ASSET__Ce0d9UPj__"